import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
import { Panel } from '@/components/ui/panel';
import { LISTING_INDEX_PAGE_STACK_CLASS, PROPOSAL_FEED_LIST_PANEL_FILL_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';
import { ProposalFeedCardSkeleton } from './proposal-feed-card-skeleton';
import { ProposalFeedListHeader } from './proposal-feed-list-header';
import { ProposalFeedRowSkeleton } from './proposal-feed-row-skeleton';
import { ProposalFeedRowMobileSkeleton } from './proposal-feed-row-skeleton.mobile';
const SKELETON_KEYS: readonly string[] = ['sk-0', 'sk-1', 'sk-2', 'sk-3', 'sk-4', 'sk-5'];
const FEED_LIST_UL_CLASS = 'grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-2 lg:grid-cols-1 lg:gap-2' as const;

/**
 * The Launchpad feed-body skeleton — the sort/filter pill bar plus the panel
 * column header and six responsive skeleton rows. Mirrors what `ProposalFeed`
 * itself renders (`ProposalFeedToolbar` + `ProposalFeedList`), WITHOUT the
 * page-level `LaunchpadHeader` (title + actions), which the layout owns and
 * keeps mounted. Shared by the route-level `loading.tsx` fallback and
 * `ProposalFeed`'s own pending branch so the two skeletons are identical and
 * the feed never re-renders a duplicate title row beneath the real header
 * (which is what shifted the loaded layout down).
 */
export function ProposalFeedSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 overflow-hidden"><Skeleton className="h-9 w-24 shrink-0 rounded-pill" /><Skeleton className="h-9 w-24 shrink-0 rounded-pill" /><Skeleton className="h-9 w-28 shrink-0 rounded-pill" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(PROPOSAL_FEED_LIST_PANEL_FILL_CLASS, "rounded-[calc(var(--radius-card)+0.75rem)] pb-3 pt-0", "max-lg:border-0 max-lg:p-0 max-lg:gap-0 max-lg:shadow-none dark:max-lg:shadow-none");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProposalFeedListHeader />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={LISTING_INDEX_PAGE_STACK_CLASS}>{t0}<Panel surface="solid" inheritBackground={true} className={t1} data-testid="launchpad-loading"><div className="flex flex-col gap-0">{t2}<ul className={FEED_LIST_UL_CLASS}>{SKELETON_KEYS.map(_temp)}</ul></div></Panel></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(key) {
  return <li key={key} className="min-w-0"><ProposalFeedRowSkeleton /><ProposalFeedCardSkeleton variant="tablet" /><ProposalFeedRowMobileSkeleton /></li>;
}